import { useState } from "react";
import "./index.css";
import Result from "./Result";

export default function Form() {
  const [query, setQuery] = useState("");
  const [visible, setVisible] = useState(false);

  const handleChange = (event) => {
    let wordTyped = event.target.value;
    setQuery(wordTyped);
    setVisible(false);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setVisible(true);
  };

  return (
    <div>
      <div className="bg-white ">
        <div className="px-4 py-5 sm:p-6">
          <form className="mt-5 sm:flex ">
            <div className="w-full sm:flex-center">
              <input
                id="search"
                name="search"
                type="search"
                placeholder="Type a word here"
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-orange-200 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                onChange={handleChange}
              />
            </div>
            <button
              type="submit"
              onClick={handleClick}
              className="mt-3 inline-flex w-full items-center justify-center rounded-md bg-orange-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:orange-indigo-500 sm:ml-3 sm:mt-0 sm:w-auto"
            >
              Search
            </button>
          </form>
        </div>
        <div className="search-result">
          {visible ? (
            <div>
              <Result word={query} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
